import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TotalRaisedWidget } from 'libs/gb-dashboard/presenter/data-access-presenter-widgets/src/lib/+state/presenter-widgets.models'
import { GbDashboardSharedUtilsModule } from 'libs/gb-dashboard/shared/utils/src/lib/gb-dashboard-shared-utils.module'
import { GbPresenterColorResolverService } from 'libs/gb-dashboard/presenter/utils/src/lib/gb-presenter-color-resolver.service'
import { GbCurrencyPipe } from 'libs/shared/utils/pipes/src/lib/gb-currency-pipe/gb-currency.pipe'

@Component({
  selector: 'gb-presenter-widget-total-raised',
  imports: [CommonModule, GbDashboardSharedUtilsModule, GbCurrencyPipe],
  templateUrl: './gb-presenter-widget-total-raised.component.html',
  styleUrl: './gb-presenter-widget-total-raised.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterWidgetTotalRaisedComponent {
  @Input({ required: true }) totalRaisedWidget!: TotalRaisedWidget
  @Input() testData = false

  constructor(private colorResolver: GbPresenterColorResolverService) {}

  get totalRaised() {
    return this.testData ? 10500 : this.totalRaisedWidget?.total_raised
  }

  get label(): string {
    return this.totalRaisedWidget?.label || ''
  }

  get backgroundColor(): string {
    return this.colorResolver.resolve(this.totalRaisedWidget?.background_color) || 'transparent'
  }

  get textColor(): string {
    return (
      this.colorResolver.resolve(this.totalRaisedWidget?.color) || this.colorResolver.resolvedGlobalColor() || '#000000'
    )
  }

  get fontFamily(): string {
    return this.totalRaisedWidget?.font_family || this.colorResolver.globalFontFamily() || ''
  }

  get fontWeight(): string {
    return this.totalRaisedWidget?.font_weight || ''
  }

  get textAlign(): string {
    return this.totalRaisedWidget?.text_align || 'center'
  }

  get fontSize(): number {
    return (this.totalRaisedWidget?.font_size ?? 30) / 8
  }

  get borderWidth(): number {
    return (this.totalRaisedWidget?.border_width || 0) / 10
  }

  get borderColor(): string {
    return this.colorResolver.resolve(this.totalRaisedWidget?.border_color) || 'transparent'
  }

  get borderStyle(): string {
    const width = this.totalRaisedWidget?.border_width || 0
    return width > 0 ? this.totalRaisedWidget?.border_style || 'solid' : 'none'
  }
}
